import React from 'react';
import moment from 'moment';

const DATE_FORMATS = {
  today: '[Today], LT',
  dateOnly: 'll',
  dateWithoutYear: 'MMM D, LT',
  full: 'lll'
};

const getDateFormat = ({ date, midDate, hideYear }) => {
  if (midDate) return DATE_FORMATS.dateOnly;
  if (moment(date).isSame(moment(), 'day')) return DATE_FORMATS.today;
  if (hideYear) return DATE_FORMATS.dateWithoutYear;
  return DATE_FORMATS.full;
};

const DateFormatter = ({ date, midDate, hideYear }) => (
  <p>{ moment(date).format(getDateFormat({ date, midDate, hideYear })) }</p>
);

export default DateFormatter;
